import { Routes, Route } from "react-router-dom";
import Welcome from "./pages/Welcome";
import Bye from "./pages/Goodbye";

const App = ()=>{

    return(
        <Routes>
            <Route path="/w" element={<Welcome/>}></Route>
            <Route path="/b" element={<Bye/>}></Route>
        </Routes>
    )
}

export default App